import { prefixLanguage } from '@utils/urls.js';

export function changeLanguage(langCode) {
  const url = window.location.href;
  document.cookie = `CHOSEN_LANGUAGE=${langCode}; path=/;`;
  window.location.assign(decodeURIComponent(prefixLanguage(url, { language: langCode })));
}
